// extracted by mini-css-extract-plugin
export default {"content":"WireInstructionsListContent_content__6RQB-","section":"WireInstructionsListContent_section__jkhSt"};